const ES = {
    title: 'Pagos',
    table: {
        title: 'Listado de Pagos',
        columns: {
            id: 'ID',
            idLink: 'N° Link',
            idPuntored: 'ID Puntored',
            dni: 'INE Vendedor',
            paymentMethod: 'Medio',
            amount: 'Monto',
            installments: 'Cuota',
            createdAt: 'Fecha',
            status: 'Estado',
        },
        paymentMethod: {
            DEBIT: 'TD',
            CREDIT: 'TC',
            PREPAID: 'TP'
        },
        filter: {
            0: {
                0: 'AUTHORIZATION_IN_PROGRESS',
                1: 'AUTHORIZATION_SKIPPED',
                2: 'AUTHORIZED',
                3: 'CONFIRMATION_ERROR',
                4: 'CONFIRMED',
                5: 'DENIED',
                6: 'NEW',
                title: 'Estado'
            },
            1: {
                0: 'Diamante',
                1: 'Zafiro',
                2: 'Oro',
                3: 'Plata',
                4: 'Bronce',
                title: 'Nivel'
            },
        },
    },
};

export default ES;
